import { mapGetters } from "vuex";
import { postAPICall } from "@/helpers/httpHelper";
import { fetchEntityById } from "../repo/entityRepo";
import { getAllFieldsArrayFromEntity } from "../utils/formatter";
import templateBuilderHelper from "../mixins/templateBuilderHelper";
import EntitiesHelper from "@/mixins/EntitiesHelper.js";
export default {
  mixins: [templateBuilderHelper, EntitiesHelper],
  data() {
    var validateEmail = (rule, value, callback) => {
      var emailReg =
        /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let emails = this.getAllContacts.data.map((user) => user.email);
      if (
        this.selectedUser &&
        this.selectedUser.email &&
        this.selectedUser.email == value
      ) {
        emails = [];
      }
      if (value === "") {
        callback(new Error("Email is Required"));
      } else if (!emailReg.test(value)) {
        callback(new Error("Email is not valid"));
      } else if (emails.indexOf(value) != -1) {
        callback(new Error("Email already existed"));
      } else {
        callback();
      }
    };
    return {
      newUserFormRules: {
        first_name: [
          {
            required: true,
            message: "First name is required",
            trigger: "blur",
          },
        ],
        last_name: [
          { required: true, message: "Last name is required", trigger: "blur" },
        ],
        company_name: [
          { required: false, message: "Company is required", trigger: "blur" },
        ],
        phone: [
          { required: false, message: "Phone is required", trigger: "blur" },
        ],

        contact_type: [
          {
            required: true,
            message: "Contact Type is required",
            trigger: "blur",
          },
        ],
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
      },
      colors: [
        "#FF9FF3",
        "#FECA57",
        "#A3CB38",
        "#1DD1A1",
        "#009432",
        "#54A0FF",
        "#0652DD",
        "#5F27CD",
        "#F368E0",
        "#00D2D3",
        "#01A3A4",
        "#FF9F43",
        "#1B1464",
        "#006266",
        "#EE5A24",
        "#833471",
        "#EA2027",
        "#9980FA",
        "#E15F41",
        "#786FA6",
        "#E66767",
        "#303952",
        "#218C74",
        "#706FD3",
      ],
      defined_colors: ["#FF495C", "#3777FF", "#EE964B", "#03CEA4"],
      relationshipEntities: [],
      selectedRole: "",
      allRoles: [],
      allAssignedRoles: [],
    };
  },
  computed: {
    ...mapGetters("menuManagementV2", [
      "getEntityMenu",
      "getAllEntityMenus",
      "getMenuManagementAddStatus",
      "getOriginalEntityMenuList",
    ]),
    ...mapGetters("entityRelationships", ["getEntityRelationships"]),
    ...mapGetters("auth", ["getActiveContactType"]),
    ...mapGetters("entities", ["getEntityDataById", "getEntityPrimaryData"]),
    ...mapGetters("applicationUsersPermission", [
      "getCreatePermissionStatus",
      "getEntityPermission",
      "getAllEntityPermissions",
      "getUpdatePermissionStatus",
    ]),
  },
  methods: {
    getUserName(id) {
      let data = this.getUserTypes.data.find((x) => x._id == id);
      return data.name || "";
    },
    getRandomColor(existColors) {
      //  console.log(existColors)
      // console.log(index)
      let filterdColors = [];
      let indx = -1;

      if (existColors && existColors.length) {
        // getting only non existed colors
        filterdColors = this.defined_colors.filter(
          (color) => existColors.indexOf(color) == -1
        );
        // console.log(filterdColors)
        if (filterdColors && filterdColors.length) {
          indx = Math.floor(Math.random() * filterdColors.length);
        } else {
          filterdColors = [];
          filterdColors = this.colors.filter(
            (color) => existColors.indexOf(color) == -1
          );
          // getting randam index of array based on length
          indx = Math.floor(Math.random() * filterdColors.length);
        }
      } else {
        filterdColors = this.defined_colors;
      }

      return filterdColors[indx];
    },
    //application user default methods
    async checkAndUpdateData(redirect_url = "") {
      try {
        if (this.getActiveContactType?.contact_type?._id) {
          let id = this.getActiveContactType?.contact_type?._id;
          let dataId = this.getActiveContactType?.account_data_id;
          await Promise.all([
            this.$store.dispatch(
              "entityRelationships/fetchEntityRelationships",
              {
                entity_id: id,
              }
            ),
            //this.$store.dispatch("menuManagementV2/fetchMenuByEntity", id),
            this.$store.dispatch("menuManagementV2/fetchAllMenusByEntity", id),
            // this.$store.dispatch(
            //   "applicationUsersPermission/fetchPermissionsEntityById",
            //   { id: id }
            // ),
            this.$store.dispatch(
              "applicationUsersPermission/fetchAllPermissionsEntityById",
              { id: id }
            ),
            this.$store.dispatch("entities/fetchEntityById", {
              entity_id: id,
            }),
            this.$store.dispatch("entities/fetchEntityPrimaryDataById", {
              id: dataId,
            }),
          ]);
          if (
            this.getEntityDataById &&
            this.getEntityDataById?.login_mode === "rbac" &&
            this.getEntityDataById?.role_details
          ) {
            await this.filterUserRoles();
            let selectedMenu = await this.filterMenu(
              this.getAllEntityMenus,
              this.selectedRole
            );
            let selectedPermission = await this.filterPermission(
              this.getAllEntityPermissions,
              this.selectedRole
            );
            this.$store.commit("menuManagementV2/setEntityMenu", selectedMenu, {
              root: true,
            });
            this.$store.commit(
              "applicationUsersPermission/setEntityPermission",
              selectedPermission
            );
          } else {
            this.$store.commit(
              "menuManagementV2/setEntityMenu",
              this.getAllEntityMenus[0],
              { root: true }
            );
            this.$store.commit(
              "applicationUsersPermission/setEntityPermission",
              this.getAllEntityPermissions[0],
              { root: true }
            );
          }
          if (
            this.getEntityRelationships &&
            this.getEntityRelationships.length
          ) {
            this.setRelationshipPermissions(id);
          }
          if (this.getEntityMenu) {
            this.$store.commit(
              "menuManagementV2/setOriginalEntityMenuList",
              this.getEntityMenu,
              { root: true }
            );
          }
          let filterIds = [];
          this.getEntityMenu?.menu_list.forEach((item) => {
            if (item?.selected_entity_filter) {
              filterIds.push(item.selected_entity_filter);
            }
          });
          if (filterIds?.length) {
            let params = {
              entity_id: id,
              entity_data_id: dataId,
              filterIds: filterIds,
            };
            const response = await postAPICall(
              "POST",
              "/entity/filtered-menu",
              params
            );
            if (response?.data) {
              let newMenu = [];
              this.getEntityMenu?.menu_list.forEach((item) => {
                if (item?.selected_entity_filter) {
                  if (response?.data[item.selected_entity_filter]) {
                    newMenu.push(item);
                  }
                } else {
                  newMenu.push(item);
                }
              });
              this.$store.commit(
                "menuManagementV2/setEntityMenu",
                {
                  ...this.getEntityMenu,
                  ...{
                    ["menu_list"]: newMenu,
                  },
                },
                { root: true }
              );
            }
          }
          if (!this.getEntityMenu) {
            if (
              this.getEntityDataById &&
              this.getEntityDataById?.login_mode === "rbac" &&
              !this.selectedRole
            ) {
              this.$router
                .push({
                  path: "/ap/no-role-assigned",
                  query: this.$route.query,
                })
                .then(() => {
                  window.location.reload();
                });
            } else {
              this.setStandardMenu(id);
            }
          } else {
            if (this.$route.path == "/ap/dashboard") {
              window.location.reload();
            } else {
              if (redirect_url) {
                this.$router.push(redirect_url);
              } else {
                window.location.replace(
                  window.location.origin + "/ap/dashboard"
                );
              }
            }
          }
        } else {
          if (this.$route.path == "/ap/dashboard") {
            window.location.reload();
          } else {
            window.location.replace(window.location.origin + "/ap/dashboard");
          }
        }
      } catch (err) {
        return err;
      }
    },
    async filterUserRoles() {
      try {
        let roleDetails = this.normalizeToArray(this.getEntityDataById?.role_details);
        const results = await Promise.all(
          roleDetails.map(async ({ roleEntity, roleName, roleLevel }) => {
            const entityData = await this.fetchEntityData(roleEntity);
            const roles = await this.filterRolesData(entityData, roleName, roleLevel);
            const taggedRoles = roles.map((r) => ({ ...r, entityId: roleEntity }));
            const fields =
              this.getEntityDataById?.templates?.flatMap((template) => {
                const rawFields = this.getTemplateFields(template.templateInfo);
                return this.applyCustomizationOnFields(
                  rawFields,
                  template.customization,
                  template
                );
              }) || [];
            const primaryRoleFieldKey =
              fields
                .map((f) =>
                  f?.primary_fields?.includes(roleName)
                    ? `${f.template_id}#${f.key}`
                    : null
                )
                .find(Boolean) || "";

            let assigned = [];
            if (primaryRoleFieldKey) {
              assigned =
                this.getEntityPrimaryData?.templates_fields_data?.[
                  primaryRoleFieldKey
                ] || [];
              assigned = this.normalizeToArray(assigned);
            }

            return { taggedRoles, assigned };
          })
        );
        const allRoles = results.flatMap((r) => r.taggedRoles);
        const allAssignedRoles = results.flatMap((r) => r.assigned);
        const assignedRoles = allRoles.filter((r) =>
          allAssignedRoles.includes(r._id)
        );
        let selectedRole = null;
        if (assignedRoles.length) {
          const rolesWithLevels = assignedRoles.filter((r) => r.level != null);
          selectedRole = rolesWithLevels.length
            ? rolesWithLevels.reduce((prev, curr) =>
                curr.level < prev.level ? curr : prev
              )._id
            : assignedRoles[0]._id;
        }
        this.allRoles = allRoles;
        this.allAssignedRoles = allAssignedRoles;
        this.selectedRole = selectedRole;
        return {
          selectedRole: this.selectedRole,
          allAssignedRoles: this.allAssignedRoles,
          allRoles: this.allRoles.filter((role) =>
            this.allAssignedRoles.includes(role._id)
          ),
        };
      } catch (err) {
        return err;
      }
    },
    normalizeToArray(value) {
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    },
    async fetchEntityData(entity_id) {
      try {
        let currentEntity = await fetchEntityById(entity_id);
        let template_fields_data = await getAllFieldsArrayFromEntity(
          currentEntity
        );
        let params = {
          entity_id: entity_id,
          template_fields_data: template_fields_data,
          format_data: true,
          filters: [],
          //sortBy: level,
          //sortOrder: "asc",
          //relationship: this.realtionshipFilter,
          limit: 500,
          page: 1,
        };
        let response = await postAPICall(
          "POST",
          "/entities-data/entity/data/v2",
          params
        );
        if (
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length
        ) {
          //this.entityData = response?.data?.data;
          return response?.data?.data;
        }
      } catch (err) {
        return err;
      }
    },
    async filterRolesData(data, roleName, roleLevel = null) {
      try {
        let templateId = roleName.split("#")[0];
        let role_name = roleName.split("#")[1];
        let role_level = roleLevel ? roleLevel.split("#")[1] : null;
        return (
          data?.map((item) => {
            const role = item.entityData[templateId];
            return {
              _id: item._id,
              name: role[role_name],
              level: role_level ? role[role_level] : null,
            };
          }) || []
        );
      } catch (err) {
        return [];
      }
    },
    async filterMenu(menus, role) {
      try {
        return menus.find((item) => item.role_id === role);
      } catch (err) {
        return {};
      }
    },
    async filterPermission(permissions, role) {
      try {
        return permissions.find((item) => item.role_id === role);
      } catch (err) {
        return {};
      }
    },
    async setStandardMenu(id) {
      let data = [];
      data.push({
        children: [],
        title: "Dashboard",
        feature: "dashboard",
        category: "",
        icon: "dashboard.svg",
        permission: "",
        isGroup: "",
        type: "Individual",
      });
      data.push({
        children: [],
        title: "My Documents",
        feature: "my_documents",
        category: "",
        icon: "File.svg",
        permission: "",
        isGroup: "",
        type: "Individual",
      });
      data.push({
        children: [],
        title: "My Workflows",
        feature: "my_workflows",
        category: "",
        type: "Individual",
        icon: "Workflows.svg",
        isGroup: "",
      });
      data.push({
        title: "My form builders",
        feature: "my_form_builders",
        category: "",
        parent: "",
        icon: "dashboard.svg",
        children: [],
        permission: "",
        isGroup: "",
        type: "Individual",
      });
      if (this.relationshipEntities && this.relationshipEntities.length) {
        this.relationshipEntities.forEach((e) => {
          data.push({
            entity_type: "RELATIONAL_ENTITY",
            children: [],
            title: "My " + (e && e.name ? e.name : "data"),
            feature: "entities",
            category: "",
            icon: "dashboard.svg",
            permission: "",
            isGroup: "",
            relational_entity: e.id,
            type: "Individual",
          });
        });
      }
      let params = {
        entity: id,
        menu_list: data,
        type: "USER",
      };
      if (
        this.getEntityDataById &&
        this.getEntityDataById?.login_mode === "rbac" &&
        this.selectedRole
      ) {
        const selectedRoleObj = this.allRoles.find(
          (role) => role._id === this.selectedRole
        );
        params["role_id"] = this.selectedRole;
        params["role_name"] = selectedRoleObj ? selectedRoleObj.name : "";
      }
      await this.$store.dispatch("menuManagementV2/addMenuManagement", params);
      if (this.getMenuManagementAddStatus) {
        //await this.$store.dispatch("menuManagementV2/fetchMenuByEntity", id);
        await this.$store.dispatch(
          "menuManagementV2/fetchAllMenusByEntity",
          id
        );
        if (
          this.getEntityDataById &&
          this.getEntityDataById?.login_mode === "rbac" &&
          this.selectedRole
        ) {
          let selectedMenu = await this.filterMenu(
            this.getAllEntityMenus,
            this.selectedRole
          );
          this.$store.commit("menuManagementV2/setEntityMenu", selectedMenu, {
            root: true,
          });
        } else {
          this.$store.commit(
            "menuManagementV2/setEntityMenu",
            this.getAllEntityMenus[0],
            { root: true }
          );
        }
        if (this.$route.path == "/ap/dashboard") {
          window.location.reload();
        } else {
          window.location.replace(window.location.origin + "/ap/dashboard");
        }
      } else {
        this.$notify.error({
          title: "Error",
          message: "Error while setting your account",
        });
      }
    },
    setRelationshipPermissions(id) {
      this.getEntityRelationships.forEach((el) => {
        if (el?.child_entity_id == id) {
          this.relationshipEntities.push({
            id: el.parent_entity_id,
            name: el.parent_relation_title,
          });
        } else if (id == el?.parent_entity_id) {
          this.relationshipEntities.push({
            id: el.child_entity_id,
            name: el.child_relation_title,
          });
        }
      });
    },
  },
};
